import type {
  BannerCampaign,
  Type,
} from '@/domains/productDiscovery/CommercialAnimation/interfaces/bannerCampaign';

export const INIT_MERCHANDIZING_BANNERS =
  'productDiscovery/merchandizingBanner/INIT';

export const FETCHING_MERCHANDIZING_BANNERS =
  'productDiscovery/merchandizingBanner/FETCHING';
export const FETCH_MERCHANDIZING_BANNERS_SUCCESS =
  'productDiscovery/merchandizingBanner/FETCH_SUCCESS';
export const FETCH_MERCHANDIZING_BANNERS_FAILED =
  'productDiscovery/merchandizingBanner/FETCH_FAILED';

export interface InitMerchandizingBanners {
  type: typeof INIT_MERCHANDIZING_BANNERS;
  bannerType: Type;
  categoryIds: string;
}

export const initMerchandizingBanners = (
  bannerType: Type,
  categoryIds: string,
): InitMerchandizingBanners => ({
  type: INIT_MERCHANDIZING_BANNERS,
  bannerType,
  categoryIds,
});

export interface FetchingMerchandizingBanners {
  type: typeof FETCHING_MERCHANDIZING_BANNERS;
  bannerType: Type;
}

export const fetchingMerchandizingBanners = (
  bannerType: Type,
): FetchingMerchandizingBanners => ({
  type: FETCHING_MERCHANDIZING_BANNERS,
  bannerType,
});

export interface FetchMerchandizingBannersSuccess {
  type: typeof FETCH_MERCHANDIZING_BANNERS_SUCCESS;
  bannerType: Type;
  campaigns?: BannerCampaign[];
}

export const fetchMerchandizingBannersSuccess = (
  bannerType: Type,
  campaigns: BannerCampaign[],
): FetchMerchandizingBannersSuccess => ({
  type: FETCH_MERCHANDIZING_BANNERS_SUCCESS,
  bannerType,
  campaigns,
});

export interface FetchMerchandizingBannersFailed {
  bannerType: Type;
  type: typeof FETCH_MERCHANDIZING_BANNERS_FAILED;
}

export const fetchMerchandizingBannerFailed = (
  bannerType: Type,
): FetchMerchandizingBannersFailed => ({
  type: FETCH_MERCHANDIZING_BANNERS_FAILED,
  bannerType,
});

export type Action =
  | InitMerchandizingBanners
  | FetchingMerchandizingBanners
  | FetchMerchandizingBannersSuccess
  | FetchMerchandizingBannersFailed;
